import { Dialog as MuiDialog, DialogActions, DialogContent } from '@mui/material';
import React from 'react';
import { ButtonOutlineMedium, ButtonPrimaryMedium } from '../Buttons';
import { BodyLargeEmphasized } from '../Typography';
import styles from './Dialog.styles';

export interface DismissDialogProps {
  onCancel: () => void;
}

interface Props {
  title: string;
  description: React.ReactNode;
  isOpen: boolean;
  icon?: React.ReactNode;
  cancelButtonText?: string;
  confirmButtonText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const DIALOG_TITLE_ID = 'alert-dialog-title';
const DIALOG_DESCRIPTION_ID = 'alert-dialog-description';

export const Dialog: React.FC<Props> = ({
  title,
  description,
  icon,
  isOpen,
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Confirm',
  onConfirm,
  onCancel,
}) => {
  return (
    <MuiDialog
      open={isOpen}
      onClose={onCancel}
      aria-labelledby={DIALOG_TITLE_ID}
      aria-describedby={DIALOG_DESCRIPTION_ID}
      className={styles.dialog}
      PaperProps={{ 'aria-modal': true }}
    >
      {icon && <div className={styles.icon}>{icon}</div>}
      <BodyLargeEmphasized className={styles.title} as="h1" id={DIALOG_TITLE_ID}> 
        {title}
      </BodyLargeEmphasized>
      <DialogContent aria-describedby={DIALOG_DESCRIPTION_ID}>{description}</DialogContent>
      <DialogActions>
        <ButtonOutlineMedium onClick={onCancel}>{cancelButtonText}</ButtonOutlineMedium>
        <ButtonPrimaryMedium autoFocus onClick={onConfirm}>
          {confirmButtonText}
        </ButtonPrimaryMedium>
      </DialogActions>
    </MuiDialog>
  );
};
